/**
 * Service-scoped slice of the global event stream.
 *
 * Locked to this service's id so the operator can't accidentally
 * widen past the entity they're focused on. Same body as the Global
 * Events tab — see `EventsStream` for the filter / rendering logic.
 */
import { EventsStream } from "@/components/EventsStream";
import type { Service } from "@/api/types";

interface Props {
  service: Service;
}

export function ServiceEvents({ service }: Props) {
  return <EventsStream lockedScope={{ service_id: service.id }} />;
}
